
import React from 'react';

import { BrowserRouter as Router, Redirect, Route,Routes, Navigate } from 'react-router-dom';









import Landing from "./pages/landingpage-pages/LandingPage";







function App() {


const [loading,setloading] = React.useState(false);
const [theme,setTheme] = React.useState('light');
const [dataSource,setDataSource] = React.useState([]);












document.addEventListener('DOMContentLoaded',function(event){
    setloading(true)


})


React.useEffect(() =>{
 
    
  
    
    
},[])

    return (
        
      
      
        
        <Router   >
         <React.Suspense fallback={<div></div>}>
             <Routess dataSource={dataSource.length > 0 ? dataSource :[]} />
         
         
         </React.Suspense>
         </Router>
         
        
        
 
      
        
        
    );
}


const Routess = ({dataSource}) =>{
  

    return(

        <Routes>
            
            
           
            <Route path={"/"} exact    element={<Landing />}  />
            <Route path={"/*"} exact    element={<Navigate to={'/'} replace={true} />}  />
           
            
            
            
          


            
           
        </Routes>
    )
}





export default App;